import BaseModelAPI from '../BaseModelAPI';

export default class PrinterInformationList extends BaseModelAPI {

	static entity = 'printerinformationlist'
	static entityName = 'printerinformation';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
